// circular import thing is not nice at all, have to use any here
const activeBatchList: any[] = [];
export const addQueryToBatch = (query: any) => {
  activeBatchList.push(query);
};
export const extractLatestBatchList = () => {
  if (activeBatchList.length === 0) return [];
  const newBatchList = [...new Set(activeBatchList)];
  activeBatchList.length = 0;
  return newBatchList;
};
